export enum Runtime {
    Node180 = 'node-18.0',
    Php80 = 'php-8.0',
    Ruby31 = 'ruby-3.1',
    Python39 = 'python-3.9',
}